<template>
  <m-categories-wrapper :single-category="category">
    <template slot-scope="{ categories,imageHandler ,setLinkType}">
      <b-container class="col-lg-12 my-5 mx-auto">

        <b-row class="">
          <b-col class="my-1" lg="4" v-for="category in setCategories(categories)"
                 :key="category.id">
            <div class="">
              <m-s517 :image-visibility="true" :image="imageHandler(category,findAttributeOnSiteInfo('icon')[0])"
                      :alt="category.name" class="w-100 category-card">
                <template #p-1>
                  <h3 class="font-weight-bold text-white">
                    {{ category.name }}
                  </h3>
                </template>
                <template #p-2>
                  <p class="text-white">
                    {{ category.description }}
                  </p>
                </template>
                <template #p-3>
                  <m-a :href="setLinkType(category,linkType)"
                       class="text-decoration-none text-white font-weight-bold">
                    مشاهده
                    <b-icon icon="plus-square" class="mr-2"></b-icon>
                  </m-a>
                </template>
              </m-s517>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </m-categories-wrapper>
</template>

<script>
export default {
  name: "categories304",
  props: {
    alternativeCategoryImage: {
      default: () => {
        return ''
      }
    },
    linkType: {
      default: 'blog'
    },
    category: {
      default: null,
    },
  },
  methods:{
    setCategories(categories){
      if(this.category != null){
        return categories[0].children
      }

      return categories

    }
  }
}
</script>

<style scoped>

</style>